const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/plan/aggregate_budgeting.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/plan/aggregate_budgeting")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Aggregate Budgets",
      description: "Title of the admin Aggregate Budgets page"
    })
  }
});